module.exports = __webpack_public_path__ + "static/book-2ef3ec11fc07b861dcdc85a5a1cb1262.jpg";